<template>
  <div>
    <div class="row border-bottom white-bg dashboard-header">
      <div class="col-lg-3">
        <h1>Spot Polls</h1>
      </div>
      <div class="col-lg-6 text-center">
        <div class="total-display">
          <el-radio-group v-model="selectedTotalDisplay" size="mini">
            <el-radio-button label="percentage">Percentage</el-radio-button>
            <el-radio-button label="total">Total</el-radio-button>
            <el-radio-button label="cume">Cume</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <br />
      <div v-if="!spotChartsData.length" class="empty">No spot surveys found.</div>
      <spot-item
        v-for="spot in spotChartsData"
        :key="spot.id"
        :id="spot.id"
        :title="spot.title"
        :url="spot.url"
        :startDate="new Date(spot.start_date)"
        :endDate="new Date(spot.end_date)"
        :entries="spot.total_entries"
        :entryChart="spot.daily_entry_rate"
        :questionCharts="spot.question_stats"
        :profileCharts="spot.profile_stats"
        :totalDisplayOption="selectedTotalDisplay"
        @onRequestRespondents="handleRequestRespondents"
      />
    </div>
    <div class="clearfix"></div>

    <fab-speed-dial
      position-type="fixed"
      icon-size="small"
      mainTooltip="New Spot Survey"
      @click="handleCreateSpotSurvey"
    />

    <spot-survey-create-dialog
      :isVisible="createDialogVisible"
      @onVisibilityChange="createDialogVisible = $event"
    />

    <survey-respondents-dialog
      :isVisible="respondentDialogVisible"
      :filtering="respondentFiltering"
      :title="respondentTitle"
      :subtitle="respondentSubtitle"
      @onVisiblityChange="handleRespondentDialogVisibility"
    />
  </div>
</template>

<script>
import IBox from '@/components/common/IBox';
import FabSpeedDial from '@/components/common/FabSpeedDial';
import Trend from '@/components/charts/Trend';
import SpotItem from '@/components/surveys/SpotItem';
import SpotSurveyCreateDialog from '@/components/surveys/SpotSurveyCreateDialog';

import { mapState } from 'vuex';

import SurveyRespondentsDialog from '@/components/surveys/SurveyRespondentsDialog';

export default {
  name: 'SpotSurveyDashboard',
  components: {
    IBox,
    Trend,
    SpotItem,
    FabSpeedDial,
    SpotSurveyCreateDialog,
    SurveyRespondentsDialog,
  },
  computed: {
    ...mapState('survey', ['spotChartsData', 'loadingSpotCharts']),
  },
  mounted() {
    this.$store.dispatch('survey/getSpotCharts');
  },
  data: () => ({
    createDialogVisible: false,
    selectedTotalDisplay: 'percentage',
    respondentDialogVisible: false,
    respondentFiltering: {},
    respondentTitle: '',
    respondentSubtitle: '',
  }),
  methods: {
    handleCreateSpotSurvey() {
      this.createDialogVisible = true;
    },
    handleRespondentDialogVisibility(event) {
      this.respondentDialogVisible = event;
    },
    handleRequestRespondents({ filtering, title, subtitle }) {
      this.respondentDialogVisible = true;
      this.respondentFiltering = filtering;
      this.respondentTitle = title;
      this.respondentSubtitle = subtitle;
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 1.2em;
}
.empty {
  text-align: center;
  font-size: 1.6em;
  color: #ccc;
  text-shadow: 2px 2px 2px #efefef;
}
</style>



// WEBPACK FOOTER //
// SpotSurveyDashboard.vue?1bf2a416